import { Component, input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronLeft, faChevronRight, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { PaginationController } from '@shared/utils/pagination';

@Component({
    selector: 'app-paginator',
    imports: [FontAwesomeModule],
    templateUrl: './paginator.component.html',
    host: {
        class: 'block w-full min-w-0',
    },
})
export class PaginatorComponent {
    /** Pagination controller produced by `createPagination`. */
    public readonly controller = input.required<PaginationController<unknown>>();
    /** Stacked, smaller controls for narrow hosts such as the chat sidebar. */
    public readonly compact = input(false);

    public readonly prevIcon: IconDefinition = faChevronLeft;
    public readonly nextIcon: IconDefinition = faChevronRight;

    public onPageSizeChange(event: Event): void {
        const value = Number((event.target as HTMLSelectElement).value);
        this.controller().setPageSize(value);
    }
}
